import { styled } from '@mui/material'

export const FeaturesList = styled('ul')(({ theme }) => ({
  marginLeft: theme.spacing(3),
  marginBottom: theme.spacing(2.5),
}))
